import {apiCall} from "../../../common/apiActionHandler";
import axios from "axios";
import {mapForSelect} from "../../../common/commonHandlers";

export const getJSALogs = (page, per_page, filters, sort, callback) => async (dispatch, getState) => {
    const config = {
        method: 'GET',
        url: `/api/crew_work_orders/jsa_logs`,
        params: {page, per_page, ...filters, ...sort}
    }

    apiCall("JSA logs load successfully", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState, false);
};

export const saveJsaForm = (jsaForm, callback) => (dispatch, getState) => {
    let config = {
        url: `/api/service_types/${jsaForm?.id}`,
        method: 'PUT',
        data: jsaForm
    };

    apiCall("Saving JSA form", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState);
};

export const searchForCustomer = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/customers/name_zip_city_search`,
        params: {q: searchText}
    };

    apiCall("Searching for customers", config, async config => {
        const response = await axios.request(config);
        callback(mapForSelect(response.data));
    }, dispatch, getState, false);
};

export const searchForWorkOrders = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/work_orders/search_work_orders`,
        params: {q: searchText}
    };

    apiCall("Searching for work orders", config, async config => {
        const response = await axios.request(config);
        callback(response?.data?.map(x => ({value: x.id, label: x.work_order_no})));
    }, dispatch, getState, false);
};

export const searchForProposals = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/proposals/search_proposals`,
        params: {q: searchText}
    };

    apiCall("Searching for proposals", config, async config => {
        const response = await axios.request(config);
        callback(response?.data?.map(x => ({value: x.id, label: x.proposal_no})));
    }, dispatch, getState, false);
};

export const getServicesTypeList = (callback) => async (dispatch, getState) => {
    const config = {
        method: 'GET',
        url: `/api/service_types`,
    }

    apiCall("Services list load successfully", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState, false);
};

export const getJsaForm = (id, callback) => async (dispatch, getState) => {
    const config = {
        method: 'GET',
        url: `api/service_types/${id}`
    }

    apiCall("JSA Form load successfully", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, dispatch, getState, false);
}